import Countdown, { CountdownRenderProps } from "react-countdown";
import { EeljProps } from "./EeljInfo";

const CountdownRenderer = (props: any) => {
  const {days, hours, minutes, seconds} = props;

  return (
    <div className="flex w-full h-full text-center justify-items-center px-6 px-4 py-6 sm:px-4 lg:grid lg:grid-cols-12 lg:gap-x-1 lg:p-1">
      <div className="h-[120px] w-full lg:col-span-3" style={{backgroundColor: 'rgba(154, 174, 187, 0.1)'}}>
          <div className="py-[10px]">
            <div className="text-[40px] font-[700] italic">{days}</div>
            <p className="lg:text-[20px] sm:text[14px]">өдөр</p>
        </div>
      </div>
      <div className="h-[120px] w-full lg:col-span-3" style={{backgroundColor: 'rgba(154, 174, 187, 0.1)'}}>
          <div className="py-[10px]">
            <div className="text-[40px] font-[700] italic">{hours}</div>
            <p className="lg:text-[20px] sm:text[14px]">цаг</p>
        </div>
      </div>
      <div className="h-[120px] w-full lg:col-span-3" style={{backgroundColor: 'rgba(154, 174, 187, 0.1)'}}>
          <div className="py-[10px]">
            <div className="text-[40px] font-[700] italic">{minutes}</div>
            <p className="lg:text-[20px] sm:text[14px]">минут</p>
        </div>
      </div>
      <div className="h-[120px] w-full lg:col-span-3" style={{backgroundColor: 'rgba(154, 174, 187, 0.1)'}}>
          <div className="py-[10px]">
            <div className="text-[40px] font-[700] italic">{seconds}</div>
            <p className="lg:text-[20px] sm:text[14px]">секунд</p>
        </div>
      </div>
    </div>
  );
}

export const EeljCountdown = (eelj: EeljProps) => {
  return (
    <div className="w-full flex flex-col items-center">
      <p>{eelj.title} захиалга эхлэхэд ({eelj.ageGroup}):</p>
      {
        new Date() > new Date(eelj.orderStartDate) ?
        <CountdownRenderer {...{days: '00', hours: '00', minutes: '00', seconds: '00'}}/>
        :
        <Countdown
          date={eelj.orderStartDate}
          renderer={(props) => {
            return (
              <CountdownRenderer {...props}/>
            )
          }}
        >
          <CountdownRenderer {...{days: '00', hours: '00', minutes: '00', seconds: '00'}}/>
        </Countdown>
      }
    </div>
  )
}

export default EeljCountdown;